export default __webpack_public_path__ + "static/media/6-7t.735051d1.png";